/**
 * Accordion bar functionality
 * @class
 */
export default class Accordion {
    /**
     * @constructor
     * @param {HTMLElement} element The accordion item bar root element
     */
    constructor(element) {
        this.el = element;
        this.items = element.querySelectorAll('[data-component="AccordionItem"]');
        this.items.forEach((D, _, A) => {
            D.ontoggle = _ => { if (D.open)
                A.forEach(d => { if (d != D)
                    d.open = false; }); };
        });
        // console.log('Accordion', this)
    }
    /**
     * Creates new instances of IAccordionUtils for each `[data-component="Accordion"]` element.
     */
    static init() {
        const AccordionEl = document.querySelector('[data-component="Accordion"]');
        if (AccordionEl) {
            const AccordionUtil = new Accordion(AccordionEl);
        }
    }
}
